/**
 * The site's header bar and footer, in React, for an interactive page that wears them
 * (the plans page).
 *
 * The same markup and classes the static pages write (`site/document.ts`), from the
 * same links (`site/nav.ts`), styled by the same `site.css` — so walking from the
 * catalog to the plans page does not change the frame around the page.
 */

import type { ReactElement } from "react";

import { BRAND_LINK, FOOTER_LINKS, FOOTER_NOTE, HEADER_LINKS } from "../site/nav.js";

function current(href: string, here: string | undefined): "page" | undefined {
  return href === here ? "page" : undefined;
}

export function SiteBar({ here }: { here?: string }): ReactElement {
  return (
    <header className="bar">
      <a className="bar-brand" href={BRAND_LINK.href}>
        {BRAND_LINK.label}
      </a>
      <nav aria-label="Site">
        {HEADER_LINKS.map((link) => (
          <a key={link.href} href={link.href} aria-current={current(link.href, here)}>
            {link.label}
          </a>
        ))}
      </nav>
    </header>
  );
}

export function SiteFoot({ here }: { here?: string }): ReactElement {
  return (
    <footer className="foot">
      <p>{FOOTER_NOTE}</p>
      <p>
        {FOOTER_LINKS.map((link, index) => (
          <span key={link.href}>
            {index > 0 ? " · " : null}
            <a href={link.href} aria-current={current(link.href, here)}>
              {link.label}
            </a>
          </span>
        ))}
      </p>
    </footer>
  );
}
